

const defaultUpGlassHeight = 300;
const defaultSideGlassWidth = 1000;
const minSideGlassWidth = 200;
const minSideGlassFromEdge = 50;
const minUpGlassHeight = 200;
const maxUpGlassHeight = 400;
const defaultSpaceUnderDoor = 100;

let buildGlassWall = (measurements) =>
{
	let result = {}
	let limits = getGlassMeasurementLimits(measurements);
	if (limits.leftSideGlassMaxWidth > 0) {
		result.leftSideGlassEnabled = true;
		result.leftSideGlassHeight = measurements.height / 2;
		result.leftSideGlassWidth = Math.min(limits.leftSideGlassMaxWidth, defaultSideGlassWidth);
	}
	else {
		result.leftSideGlassEnabled = false;
		result.leftSideGlassHeight = measurements.height / 2;
		result.leftSideGlassWidth = 200;
	}
	if (limits.rightSideGlassMaxWidth > 0) {
		result.rightSideGlassEnabled = true;
		result.rightSideGlassHeight = measurements.height / 2;
		result.rightSideGlassWidth = Math.min(limits.rightSideGlassMaxWidth, defaultSideGlassWidth);
	}
	else {
		result.rightSideGlassEnabled = false;
		result.rightSideGlassHeight = measurements.height / 2;
		result.rightSideGlassWidth = 200;
	}	
	result.upGlassHeight = defaultUpGlassHeight;
	result.doorHeight = measurements.height - defaultUpGlassHeight - defaultSpaceUnderDoor;
	result.upGlassEnabled = true;
	result.allowAddOrRemoveGlass = true;
	result = Object.assign(result, limits);
	return result;
};
let getGlassMeasurementLimits = (measurements) => {
	let result = {}

	let spaceForLeftSideGlass = measurements.doorFromLeft - minSideGlassFromEdge;
	result.leftSideGlassMaxWidth = spaceForLeftSideGlass >= minSideGlassWidth ? spaceForLeftSideGlass : 0;	
	result.leftSideGlassMinWidth = minSideGlassWidth;
	result.leftSideGlassMaxHeight = measurements.height;
	result.leftSideGlassMinHeight = defaultUpGlassHeight;

	let spaceAtRightSideGlass = measurements.doorWallWidth - measurements.doorFromLeft - measurements.doorWidth - minSideGlassFromEdge;
	result.rightSideGlassMaxWidth = spaceAtRightSideGlass >= minSideGlassWidth ? spaceForLeftSideGlass : 0;
	result.rightSideGlassMinWidth = minSideGlassWidth;
	result.rightSideGlassMaxHeight = measurements.height;

	result.rightSideGlassMinHeight = defaultUpGlassHeight;
	result.minUpGlassHeight = minUpGlassHeight;
	result.maxUpGlassHeight = maxUpGlassHeight;
	return result;
}


export { buildGlassWall,getGlassMeasurementLimits };